<template>
  <div class="buynowOrderSubmit" >
    <div class="pageContent">
      <XR-head titleText="订单确认" :rightShow="true" ref="headObj"></XR-head>

      <router-link to="/usercenter/address?redirecturl=/usercenter/address">
        <div class="receive-address">          
          <div class="mapIcon">
            <i class="fa fa-location"></i>
          </div>
          <div class="address-info" :style="{width:addressInfoWidth+'px'}">
            <div class="contract">
              <span class="name">{{receiveAddress.Receiver}}</span>
              <span class="mobile">{{receiveAddress.Phone}}</span>
            </div>
            <div class="address-content">
              <span class="text">{{receiveAddress.DetailAddress}}</span>
            </div>
          </div>
          <div class="goIcon">
            <i class="fa fa-angle-right"></i>
          </div>
        </div>
      </router-link>

      <div class="pro-list">
        <div class="pro-item" v-for="pItem in productInfoList" :key="pItem.SkuId">
          <div class="pro-img">
            <img :src="pItem.ImgPath?pItem.ImgPath:IMGServer_URL+'/images/index-item-default.png'" />
          </div>
          <div class="pro-info" :style="{width:cartItemProductInfoWidth+'px'}">
            <p class="pro-name">{{pItem.ProductName}}</p>
            <p class="pro-attr">
              {{pItem.SellerPointer}}
            </p>
            <div class="pro-num">
              <p class="pro-price"><i class="fa fa-rmb"></i>{{pItem.BuyNowPrice.toFixed(2)}}</p>
              <div class="count">x 1</div>
            </div>
          </div>
        </div>
      </div>
      <div class="choose-info delivery"  @click="open('delivery')">
        <div class="info left">
          <div class="choose-row title">选择配送</div>
        </div>    
        <div class="goIcon">
          <i class="fa fa-angle-right"></i>
        </div> 
        <div class="info center" :style="{width:chooseInfoWidth+'px'}">
          <div class="choose-row">{{shippingMethodName}}</div>
          <div class="choose-row">{{shippingDateName}}</div>
        </div>
        <mu-popup position="bottom" popupClass="buynowOrderSubmit-popupLayer delivery" :open="deliveryPopup" @close="close('delivery')">
          <mu-sub-header>请选择送货方式</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="methodItem in shippingMethodList">
              <mu-raised-button :label="methodItem.method" :class="shippingMethodInfo.id==methodItem.Id?'shippingBtn select':''" @click="selectShippingMethod(methodItem.Id,methodItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-sub-header>请选择送货时间</mu-sub-header>
          <div class="deliveryChoose">
            <template v-for="dateItem in shippingDateList">
              <mu-raised-button :label="dateItem.method" :class="shippingDateInfo.id==dateItem.Id?'shippingBtn select':''" @click="selectShippingDate(dateItem.Id,dateItem.method)"></mu-raised-button>
            </template>
          </div>
          <mu-raised-button primary @click="choseDelivery()" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>
      <div class="choose-info">
        <div class="info left">
          <div class="choose-row title">发票</div>
        </div>   
        <div class="info center" :style="{width:chooseInfoWidth+'px'}">
          <div class="choose-row"><mu-switch v-model="isFapiao" /></div>
          <div class="choose-row">{{orderInfo.invoiceHead ? '抬头：'+orderInfo.invoiceHead:''}}</div>
        </div>
        <!-- <div class="goIcon">
          <i class="fa fa-angle-right"></i>
        </div> -->
        <mu-popup position="bottom" popupClass="buynowOrderSubmit-popupLayer fapiao" :open="fapiaoPopup" @close="close('fapiao')">
          <div class="deliveryChoose">
            <mu-text-field fullWidth label="请输入发票抬头" labelFloat v-model="orderInfo.invoiceHead" />
          </div>
          <mu-raised-button primary @click="closeChoose('fapiao')" fullWidth class="delvieryChooseBtn" label="确定"/>
        </mu-popup>
      </div>

      <div class="remark">
        <mu-text-field hintText="选填:给商家留言" v-model="orderInfo.remark" fullWidth multiLine :rows="1" :rowsMax="6" :maxLength="50"/>
      </div>

      <div class="price-info">
        <div class="row">
          <p class="title">商品金额</p>
          <p class="price">
            <i class="fa fa-rmb"></i>
            <span>{{totalPrice.toFixed(2)}}</span>
          </p>
        </div>
        <div class="row">
          <p class="title">运费</p>
          <p class="price">
            <span>+</span>
            <i class="fa fa-rmb"></i>
            <span>{{freightPrice}}</span>
          </p>
        </div>
        <!--<div class="row">
          <p class="title">积分抵扣</p>
          <p class="price">
            <span>-</span>
            <i class="fa fa-rmb"></i>
            <span>0.00</span>
          </p>
        </div>-->
      </div>

      <mu-divider />
      <div class="bottom-bar">
        <mu-row >
          <mu-col width="65" tablet="65" desktop="65">
            <p class="cart-total">
              <span>实付款：<i class="fa fa-rmb"></i></span>
              <span class="money">{{totalPayPrice.toFixed(2)}}</span>
            </p>
          </mu-col>
          <mu-col width="35" tablet="35" desktop="35">
            <mu-flat-button label="提交订单" class="gobuy" backgroundColor="red" color="white" fullWidth @click="orderSubmit" />
          </mu-col>
        </mu-row>
      </div>
    </div>
    <XR-toast @onClose="submitSuccess" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      cartItemProductInfoWidth: (parseInt(document.documentElement.clientWidth)-130),
      addressInfoWidth: (parseInt(document.documentElement.clientWidth)-70) ,
      chooseInfoWidth: (parseInt(document.documentElement.clientWidth)-190) ,      
      deliveryPopup: false,
      fapiaoPopup: false,
      integralPopup: false,
      isFapiao: false,
      isIntegral: false,
      integral:'',
      productInfoList:[],
      receiveAddress :{},
      totalPrice : 0,
      totalPayPrice : 0,
      shippingMethodInfo:{id:0,name:''},
      shippingDateInfo:{id:0,name:''},
      shippingMethodName:'',
      shippingDateName:'',
      orderInfo:{
        twoOrderType:3,
        invoiceHead:'',
        remark:'',
        shopOrder:[],
        addrId:0,
        shippingMethodId:0,
        shippingDateId:0,
        isIntegral:false,
        integral:0,
        isBaw:false,
        baw:0
      },
      shippingMethodList:[],
      shippingDateList:[],
      orderNos:[],
      freightPrice: 0      
    }
  },
  mounted:function(){
    this.$refs.XRtoast.load()
    this.getDefaultAddress()
    this.getProductDetail()
    this.getShippingDateList()
    this.getShippingMethodList()
  },
  methods: {
    open (obj) {
      this[obj+'Popup'] = true
      if(obj == 'delivery'){
        this.shippingMethodInfo.id = this.orderInfo.shopOrder[0].shippingMethodId
        this.shippingMethodInfo.name = this.shippingMethodName
        this.shippingDateInfo.id = this.orderInfo.shopOrder[0].shippingDateId
        this.shippingDateInfo.name = this.shippingDateName
      }
      else if(obj == 'integral'){
      }
      else if(obj == 'fapiao'){
      }
    },
    close (obj) {
      this[obj+'Popup'] = false
      if(obj == 'integral'){
        this.isIntegral = false
      }
      else if(obj == 'fapiao'){
        this.isFapiao = false
      }      
    },
    closeChoose(obj){
      this[obj+'Popup'] = false
      if(obj == 'integral'){
        if(this.isIntegral){
          var integral = parseInt(this.integral)
          if(this.integral>0){
            this.orderInfo.isIntegral = true
            this.orderInfo.integral = integral
          }else{            
            this.integral = ''
            this.isIntegral = false
          }
        }
      }
      else if(obj == 'fapiao'){
        if(!this.orderInfo.invoiceHead){
          this.isFapiao = false
        }
      }
    },
    getDefaultAddress(){
      var ths = this
      ths.$post(
        "/Shop/UserServer/GetDefaultReceiveAddress"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.$refs.XRtoast.hide()
          ths.receiveAddress = res.Data
          ths.orderInfo.addrId = res.Data.Id
          ths.loaded = false
        }
      });
    },
    getFreight(){
      var ths = this
      ths.$post(
        "/Shop/RetailServer/GetFreightByAddressCode",
        JSON.stringify({
          provinceCode:this.receiveAddress.Province,
          cityCode: this.receiveAddress.City,
          areaCode: this.receiveAddress.Area,
          skus: this.orderInfo.shopOrder[0].productList
        })
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.$refs.XRtoast.hide()
          ths.loaded = false
          ths.freightPrice = res.Data
          ths.totalPayPrice = ths.totalPrice + ths.freightPrice; 
        }
      });
    },
    getProductDetail(){
      var ths = this
      
      var skuId = this.$route.query.skuId
      if(skuId){
        skuId = parseInt(skuId)
      }
      if(typeof skuId != "number"){
        return
      }
      var pId = this.$route.query.pId
      this.orderInfo.shopOrder = [
        {
          productList:[
            {skuId: skuId, count:1 , ByPid:pId }
          ]
        }
      ]
      var data = {productId:pId}

      ths.$post(
        "/Shop/RetailServer/GetActivityBuyNowProductInfoByProductId",
        JSON.stringify(data)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.orderInfo.shopOrder[0].shopId = res.Data.ShopId
          ths.productInfoList.push(res.Data)
          ths.totalPrice += res.Data.BuyNowPrice * 1
          ths.totalPayPrice = ths.totalPrice + ths.freightPrice; 
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },    
    getShippingDateList(){    
      var ths = this  
      ths.$post(
        "/Shop/RetailServer/GetShippingDateList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{    
          ths.shippingDateList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    getShippingMethodList(){   
      var ths = this 
      ths.$post(
        "/Shop/RetailServer/GetShippingMethodList"
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{  
          ths.shippingMethodList = res.Data
          ths.$refs.XRtoast.hide()
          ths.loaded = false
        }
      });
    },
    selectShippingDate(id, name){
      this.shippingDateInfo.id = id
      this.shippingDateInfo.name = name
    },
    selectShippingMethod(id, name){
      this.shippingMethodInfo.id = id
      this.shippingMethodInfo.name = name
    },
    choseDelivery(){
      if(!this.shippingMethodInfo.id){
        this.$refs.XRtoast.failed('请选择发货方式', true)
        return
      }
	  if(!this.shippingDateInfo.id){
        this.$refs.XRtoast.failed('请选择送货时间', true)
        return
      }
	
      this.orderInfo.shippingMethodId = this.shippingMethodInfo.id
      this.shippingMethodName = this.shippingMethodInfo.name
      this.orderInfo.shippingDateId = this.shippingDateInfo.id
      this.shippingDateName = this.shippingDateInfo.name
	  
      this.close('delivery')
      this.getFreight()
    },
    orderSubmit(){
      if(this.orderInfo.shippingMethodId==0){
        this.$refs.XRtoast.failed("请选择发货方式", true)
        return
      }
      if(this.orderInfo.shippingDateId==0){
        this.$refs.XRtoast.failed("请选择送货时间", true)
        return
      }

      var ths = this
      ths.$post(
        "/Shop/RetailServer/OrderSubmit",
        JSON.stringify(this.orderInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{      
          ths.orderNos = res.Data
          ths.$refs.XRtoast.success(res.Msg, true)
          cart.clearSelectList()
        }
      });
    },
    submitSuccess(){
      this.$router.push('/retail/orderPay?orderNo='+this.orderNos.join(','))
    }
  },
  watch :{
    isFapiao:function(){
      if(this.isFapiao){
        this.open('fapiao')
      }else{
        this.orderInfo.invoiceHead=''
      }
    },
    isIntegral:function(){
      if(this.isIntegral){
        this.open('integral')
      }else{
        this.integral = ''
        this.orderInfo.isIntegral = false
        this.orderInfo.integral =0
      }
    },
    productList: function(){
      var price = 0;
      for(var i = 0; i< this.productList.length;i++){
        for(var j = 0; j< this.orderInfo.shopOrder[0].productList.length;j++){
          if(this.productList[i].SkuId == this.orderInfo.shopOrder[0].productList[j].skuId){            
            price += this.productList[i].SalePrice * this.orderInfo.shopOrder[0].productList[j].count
          }
        }
      }
      this.totalPrice = price
    }
  }
}
</script>
<style>
.buynowOrderSubmit{
  background: #F0F2F5;
  bottom: unset;
}
.buynowOrderSubmit .pageContent{
  padding-bottom: 56px;
}

.buynowOrderSubmit .goIcon{
  width: 20px;
  float: right;
  text-align: right;
}

.buynowOrderSubmit .mapIcon{
  float: left;
  width: 30px;
  line-height: 64px;
}

.buynowOrderSubmit .receive-address{
  background: white;
  color:black;
  padding: 10px;
  overflow: hidden;
}
.buynowOrderSubmit .receive-address .address-info{
  float: left;
}
.buynowOrderSubmit .receive-address .address-info .name{
  font-size:16px;
  font-weight: 700;
  padding-right: 15px;
}
.buynowOrderSubmit .receive-address .address-info .mobile{
  font-size:16px;
  font-weight: 700;
}
.buynowOrderSubmit .receive-address .address-info .address-content{
  font-size:12px;
  line-height: 18px;
  color:#999;
}
.buynowOrderSubmit .receive-address .address-info .address-content .fa{
  width: 20px;
}
.buynowOrderSubmit .receive-address .goIcon{
  line-height: 64px;
}

.buynowOrderSubmit .choose-info{
  overflow: hidden;
  padding:10px;
  background: white;
  margin-top: 10px;
}
.buynowOrderSubmit .choose-info .info{
  font-size: 12px;
  float: left;
  line-height: 24px;
}
.buynowOrderSubmit .choose-info .info.center{
  float: right;
}
.buynowOrderSubmit .choose-info .info.left {
  width: 150px;
}
.buynowOrderSubmit .choose-info .info.left .title{
  font-size: 14px;
  font-weight: 700;
}
.buynowOrderSubmit .choose-info .info .choose-row{
  line-height: 24px;
}
.buynowOrderSubmit .choose-info .info.center .choose-row{
  text-align: right;
}
.buynowOrderSubmit .choose-info.integral .info.left .choose-row.balance{
  color:red;
}
.buynowOrderSubmit .choose-info .goIcon{
  line-height: 48px;
}

.buynowOrderSubmit .remark{
  background: white;
  margin-top: 10px;
  padding:10px 10px 0;
}

.buynowOrderSubmit .price-info{
  background: white;
  margin-top: 10px;
  padding:10px 10px 40px;
}
.buynowOrderSubmit .price-info .row{
  background: white;
  overflow: hidden;
  line-height: 32px;
}
.buynowOrderSubmit .price-info .row .title{
  font-size: 14px;
  font-weight: 700;
}
.buynowOrderSubmit .price-info .row .price{
  color:Red;
  font-weight: 700;
}



.buynowOrderSubmit .pro-list{
  margin-top: 10px;
  background: white;
  overflow: hidden;
}
.buynowOrderSubmit .pro-list .pro-item{
  padding: 16px 0;
  overflow: hidden;
}
.buynowOrderSubmit .pro-list .pro-item .pro-img{
  width: 80px;
  float: left;
}
.buynowOrderSubmit .pro-list .pro-item .pro-img img{
  width: 100%;
  display: block;
  border-radius: 4px;
  margin: 0 20px;
}
.buynowOrderSubmit .pro-list .pro-item .pro-info{
  float: right;
  padding-right: 10px;
}
.buynowOrderSubmit .pro-list .pro-item .pro-info .pro-name{
  font-size: 12px;
  line-height: 16px;
  height: 32px;
  padding-bottom: 4px;
  overflow: hidden;
}
.buynowOrderSubmit .pro-list .pro-item .pro-info .pro-attr{
  font-size: 12px;
  line-height: 16px;
  height: 30px;
  color:#999;
}
.buynowOrderSubmit .pro-list .pro-item .pro-info .pro-num{
  font-size: 12px;
  line-height: 16px;
  height: 16px;
  color:#999;
}
.buynowOrderSubmit .pro-list .pro-item .pro-info .pro-num .pro-price{
  font-size: 16px;
  line-height: 16px;
  float: left;
  color:red;
}
.buynowOrderSubmit .pro-list .pro-item .pro-info .pro-num .count{
  font-size: 12px;
  line-height: 16px;
  color:#999;
  float: right;
}




.buynowOrderSubmit .bottom-bar{
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: white;
  height: 56px;
  border-top:1px solid #eee;
}
.buynowOrderSubmit .bottom-bar .cart-total{
  float: left;
  height: 56px;
  line-height: 56px;
  padding-left: 20px;
  font-size: 16px;
  font-weight: 700;
  color:Red;
}
.buynowOrderSubmit .gobuy{
  width: 100%;
  line-height: 56px;
  height: 56px;
  text-align: center;
}

.buynowOrderSubmit-popupLayer {
  width: 100%;
  min-height: 120px;
}
.buynowOrderSubmit-popupLayer .deliveryChoose {
  padding: 0 10px;
}
.buynowOrderSubmit-popupLayer .delvieryChooseBtn{
  margin: 40px 0 0;
  height: 50px; 
}

.buynowOrderSubmit-popupLayer .shippingBtn.select{
  background: red;
  color:white;
}

</style>



// WEBPACK FOOTER //
// src/pages/retail/buyNowOrderSubmit.vue